import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import type {ProgressConfiguration} from '../../../api/columns/contracts/progress'
import {BaseColumnModel} from '../abstract/base'

export class SubIssuesProgressColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.SubIssuesProgress
  declare readonly dataType: typeof MemexColumnDataType.SubIssuesProgress
  declare readonly userDefined: false
  declare readonly settings: {
    width: number
    progressConfiguration: ProgressConfiguration
  }
}
